import ApisServiceApp from '@api/ApisServiceApp'
import { IOrder } from '@interfaces/orderInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function createOrder(data: IOrder) {
  try {
    return ApisServiceApp.post('/don-hang/create-don-hang', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function updateOrder(data: IOrder) {
  try {
    return ApisServiceApp.put('/don-hang/' + data.id + '/update-don-hang', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getDetailOrder(id: string) {
  try {
    return ApisServiceApp.get('/don-hang/' + id + '/chi-tiet-don-hang')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** Tăng số lần in đơn hàng - POST /don-hang/{id}/in */
export function incrementOrderPrintCount(id: string) {
  return ApisServiceApp.post('/don-hang/' + id + '/in')
}


export function getListOrder(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/don-hang/filter-don-hang', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** Danh sách đơn hàng tất cả chi nhánh (backend chỉ cố định theo duAnId) */
export function getListOrderAllBranch(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/don-hang/filter-don-hang-all-branch', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListOptionOrder(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/don-hang/filter-don-hang', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteOrder(id: string) {
  try {
    return ApisServiceApp.delete('/don-hang/' + id + '/delete-don-hang')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteMultiOrder(idArr: Array<string>) {
  try {
    return ApisServiceApp.delete('/don-hang/bulk-delete-don-hang', { data: idArr })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}



// đơn mua
export function getListOrderPick(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/don-hang/filter-don-hang', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListOrderCheck(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/don-hang/filter-don-hang', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// đơn mua
export function getListOrderPack(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/don-hang/filter-don-hang', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListOrderSchedule(querySt?: string) {
  return getListOrderAllBranch(querySt)
}

export function getListOrderShip(querySt?: string) {
  return getListOrderAllBranch(querySt)
}

// đơn mua
export function updateResetOrder(id: string, trangThai: string) {
  try {
    return ApisServiceApp.post('/don-hang/' + id + '/reset-don-hang', {
      trangThaiDon: trangThai
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function overrideOrderStatus(id: string, trangThaiDon: string, lyDo: string) {
  try {
    return ApisServiceApp.post('/don-hang/' + id + '/override-trang-thai', {
      trangThaiDon,
      lyDo,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** Chuyển toàn bộ liên kết workflow từ đơn nguồn sang đơn đích */
export function transferOrderWorkflowLinks(
  donHangNguonId: number,
  donHangDichId: number,
  trangThaiDonDichCanGan: string
) {
  try {
    return ApisServiceApp.post('/don-hang/chuyen-doi-lien-ket', {
      donHangNguonId,
      donHangDichId,
      trangThaiDonDichCanGan,
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

